// AUTO-GENERATED from config/permissions.yml — DO NOT EDIT
// Source SHA: 18492451d94bd0ef8e0819e564c7e7f6743163cb72deb323f47e11382cd0ebb9
// Run `bin/rake permissions:sync` to regenerate

export type Permission =
  | 'accessible_ip_addresses:read'
  | 'accessible_ip_addresses:write'
  | 'billings:read'
  | 'billings:write'
  | 'brands:write'
  | 'consumables:export'
  | 'consumables:read'
  | 'consumables:write'
  | 'contact_addresses:export'
  | 'contact_addresses:read'
  | 'contact_addresses:write'
  | 'ec_accounts:read'
  | 'ec_accounts:write'
  | 'governance:export'
  | 'governance:read'
  | 'governance:write'
  | 'inbounds:export'
  | 'inbounds:read'
  | 'inbounds:write'
  | 'integrations:read'
  | 'integrations:write'
  | 'inventories:approve'
  | 'inventories:export'
  | 'inventories:read'
  | 'inventories:write'
  | 'inventory_transformations:write'
  | 'inventory_type_reclassify_rules:write'
  | 'logs:read'
  | 'merchants:write'
  | 'operators:read'
  | 'operators:write'
  | 'orders:export'
  | 'orders:read'
  | 'orders:write'
  | 'organizations:read'
  | 'organizations:write'
  | 'products:export'
  | 'products:read'
  | 'products:write'
  | 'purchase_orders:approve'
  | 'purchase_orders:export'
  | 'purchase_orders:read'
  | 'purchase_orders:write'
  | 'reports:read'
  | 'return_orders:export'
  | 'return_orders:read'
  | 'return_orders:write'
  | 'shelves:export'
  | 'shelves:read'
  | 'shelves:write'
  | 'shipping_accounts:read'
  | 'shipping_accounts:write'
  | 'suppliers:read'
  | 'suppliers:write'
  | 'users:read'
  | 'users:write'
  | 'warehouses:write'
  | 'webhooks:read'
  | 'webhooks:write'
  | 'work_orders:read'
  | 'work_orders:write';

export const PERMISSION_MANIFEST = {
  'api/admin/v1/accessible_ip_addresses': {
    batch_delete: 'accessible_ip_addresses:write',
    create: 'accessible_ip_addresses:write',
    current_ip: 'accessible_ip_addresses:read',
    destroy: 'accessible_ip_addresses:write',
    index: 'accessible_ip_addresses:read',
    show: 'accessible_ip_addresses:read',
  },
  'api/admin/v1/analytics/sla': {
    overdue_orders: 'orders:read',
    summary: 'orders:read',
  },
  'api/admin/v1/background_jobs': {
    batch_status: 'open',
    cancel: 'open',
  },
  'api/admin/v1/billings': {
    show: 'billings:read',
    update: 'billings:write',
  },
  'api/admin/v1/brands': {
    create: 'brands:write',
    destroy: 'brands:write',
    get_ids: 'open',
    get_records: 'open',
    index: 'open',
    show: 'open',
    update: 'brands:write',
  },
  'api/admin/v1/bundles': {
    create: 'products:write',
    destroy: 'products:write',
    edit: 'products:read',
    export: 'products:export',
    get_ids: 'products:read',
    get_records: 'products:read',
    import: 'products:write',
    index: 'products:read',
    new: 'products:read',
    show: 'products:read',
    update: 'products:write',
  },
  'api/admin/v1/common_options': {
    index: 'open',
  },
  'api/admin/v1/consumables': {
    check_barcode: 'consumables:read',
    create: 'consumables:write',
    destroy: 'consumables:write',
    edit: 'consumables:read',
    get_ids: 'consumables:read',
    get_records: 'consumables:read',
    index: 'consumables:read',
    new: 'consumables:read',
    show: 'consumables:read',
    update: 'consumables:write',
  },
  'api/admin/v1/contact_addresses': {
    create: 'contact_addresses:write',
    destroy: 'contact_addresses:write',
    edit: 'contact_addresses:read',
    export: 'contact_addresses:export',
    get_ids: 'contact_addresses:read',
    get_records: 'contact_addresses:read',
    import: 'contact_addresses:write',
    index: 'contact_addresses:read',
    new: 'contact_addresses:read',
    show: 'contact_addresses:read',
    update: 'contact_addresses:write',
  },
  'api/admin/v1/dashboard': {
    settings: 'open',
    update_settings: 'open',
  },
  'api/admin/v1/ec_accounts': {
    coupang_shipping_info: 'ec_accounts:read',
    create: 'ec_accounts:write',
    destroy: 'ec_accounts:write',
    get_records: 'ec_accounts:read',
    index: 'ec_accounts:read',
    schedule_fetch: 'ec_accounts:write',
    show: 'ec_accounts:read',
    sync_product_mappings: 'ec_accounts:write',
    sync_stock: 'ec_accounts:write',
    test_connection: 'ec_accounts:write',
    update: 'ec_accounts:write',
  },
  'api/admin/v1/flexible_products': {
    create: 'products:write',
    destroy: 'products:write',
    edit: 'products:read',
    get_ids: 'products:read',
    get_records: 'products:read',
    index: 'products:read',
    new: 'products:read',
    show: 'products:read',
    update: 'products:write',
  },
  'api/admin/v1/fulfillments': {
    change_shipping_type: 'orders:write',
    merge: 'orders:write',
    mergeable_groups: 'orders:read',
  },
  'api/admin/v1/governance/accounts': {
    reactivate: 'governance:write',
    suspend: 'governance:write',
  },
  'api/admin/v1/governance/ai_credit_purchases': {
    create: 'governance:write',
    index: 'governance:read',
    packs: 'governance:read',
  },
  'api/admin/v1/governance/ai_wallet': {
    consume: 'governance:write',
    show: 'governance:read',
    update_daily_budget: 'governance:write',
  },
  'api/admin/v1/governance/billing_profiles': {
    show: 'governance:read',
    update: 'governance:write',
  },
  'api/admin/v1/governance/invoices': {
    cancel: 'governance:write',
    index: 'governance:read',
    pay: 'governance:write',
    show: 'governance:read',
  },
  'api/admin/v1/governance/payment_methods': {
    bind_card: 'governance:write',
    destroy: 'governance:write',
    index: 'governance:read',
    sdk_token: 'governance:write',
    set_default: 'governance:write',
  },
  'api/admin/v1/governance/usage_records': {
    index: 'governance:read',
    summary: 'governance:read',
  },
  'api/admin/v1/import_templates': {
    create: 'merchants:write',
    destroy: 'merchants:write',
    download: 'open',
    get_ids: 'open',
    get_records: 'open',
    index: 'open',
    schema_fields: 'open',
    show: 'open',
    update: 'merchants:write',
  },
  'api/admin/v1/imports': {
    get_records: 'products:read',
    show: 'products:read',
  },
  'api/admin/v1/inbounds': {
    cancel: 'inbounds:write',
    create: 'inbounds:write',
    destroy: 'inbounds:write',
    edit: 'inbounds:read',
    export: 'inbounds:export',
    generate_labels: 'inbounds:read',
    generate_pdf: 'inbounds:read',
    get_ids: 'inbounds:read',
    get_records: 'inbounds:read',
    import: 'inbounds:write',
    index: 'inbounds:read',
    new: 'inbounds:read',
    resume: 'inbounds:write',
    serial_numbers_get_records: 'inbounds:read',
    show: 'inbounds:read',
    suggest_name: 'inbounds:read',
    update: 'inbounds:write',
  },
  'api/admin/v1/integrations': {
    available_scopes: 'open',
    create: 'integrations:write',
    destroy: 'integrations:write',
    edit: 'integrations:read',
    get_records: 'integrations:read',
    index: 'integrations:read',
    new: 'integrations:read',
    regenerate_token: 'integrations:write',
    show: 'integrations:read',
    toggle_active: 'integrations:write',
    update: 'integrations:write',
  },
  'api/admin/v1/inventories': {
    export: 'inventories:export',
    get_ids: 'inventories:read',
    get_records: 'inventories:read',
    index: 'inventories:read',
    orders: 'inventories:read',
  },
  'api/admin/v1/inventory_attribute_definitions': {
    create: 'merchants:write',
    destroy: 'merchants:write',
    index: 'open',
    update: 'merchants:write',
  },
  'api/admin/v1/inventory_holds': {
    batch_release: 'inventories:write',
    create: 'inventories:write',
    get_ids: 'inventories:read',
    get_records: 'inventories:read',
    show: 'inventories:read',
  },
  'api/admin/v1/inventory_monitors': {
    batch_delete: 'inventories:write',
    create: 'inventories:write',
    destroy: 'inventories:write',
    export_insufficient: 'inventories:export',
    get_ids: 'inventories:read',
    get_records: 'inventories:read',
    show: 'inventories:read',
    toggle_alert: 'inventories:write',
    update: 'inventories:write',
  },
  'api/admin/v1/inventory_movements': {
    export: 'inventories:export',
    get_ids: 'inventories:read',
    get_records: 'inventories:read',
  },
  'api/admin/v1/inventory_shelves': {
    get_records: 'inventories:read',
    index: 'inventories:read',
  },
  'api/admin/v1/inventory_snapshots': {
    export: 'inventories:export',
    get_ids: 'inventories:read',
    get_records: 'inventories:read',
  },
  'api/admin/v1/inventory_transformations': {
    create: 'inventory_transformations:write',
    get_records: 'inventories:read',
    show: 'inventories:read',
    suggest_name: 'inventory_transformations:write',
  },
  'api/admin/v1/inventory_type_reclassify_rules': {
    create: 'inventory_type_reclassify_rules:write',
    destroy: 'inventory_type_reclassify_rules:write',
    get_ids: 'inventories:read',
    get_records: 'inventories:read',
    index: 'inventories:read',
    show: 'inventories:read',
    update: 'inventory_type_reclassify_rules:write',
  },
  'api/admin/v1/inventory_types': {
    index: 'open',
  },
  'api/admin/v1/invoice_payments': {
    create: 'purchase_orders:write',
    destroy: 'purchase_orders:write',
  },
  'api/admin/v1/memories': {
    create: 'open',
    destroy: 'open',
    index: 'open',
  },
  'api/admin/v1/merchant_billings': {
    index: 'billings:read',
    show: 'billings:read',
  },
  'api/admin/v1/merchant_inventory_types': {
    index: 'open',
    update: 'merchants:write',
  },
  'api/admin/v1/merchants': {
    index: 'open',
    show: 'open',
    update_order_item_columns: 'merchants:write',
  },
  'api/admin/v1/notification_subscriptions': {
    show: 'open',
    update: 'open',
  },
  'api/admin/v1/notifications': {
    get_ids: 'open',
    get_records: 'open',
    index: 'open',
    read_all: 'open',
    set_read: 'open',
    show: 'open',
    unread_count: 'open',
  },
  'api/admin/v1/order_attachments': {
    create: 'orders:write',
    destroy: 'orders:write',
  },
  'api/admin/v1/order_holds': {
    batch_release: 'orders:write',
    get_ids: 'orders:read',
    get_records: 'orders:read',
  },
  'api/admin/v1/order_post_processors': {
    create: 'merchants:write',
    destroy: 'merchants:write',
    edit: 'open',
    get_records: 'open',
    index: 'open',
    new: 'open',
    show: 'open',
    update: 'merchants:write',
  },
  'api/admin/v1/order_serial_numbers': {
    get_records: 'orders:read',
  },
  'api/admin/v1/order_templates': {
    ai_chat: 'orders:write',
    analyze_pdf: 'orders:write',
    create: 'orders:write',
    default_template: 'open',
    destroy: 'orders:write',
    edit: 'orders:read',
    get_records: 'orders:read',
    index: 'orders:read',
    new: 'orders:read',
    sample_reserved_barcode_area: 'open',
    show: 'orders:read',
    update: 'orders:write',
  },
  'api/admin/v1/orders': {
    analytics: 'orders:read',
    batch_cancel: 'orders:write',
    batch_check: 'orders:write',
    batch_convert_to_draft_order: 'orders:write',
    batch_convert_to_urgent_order: 'orders:write',
    batch_create_return_order: 'orders:write',
    batch_draft_order_convert: 'orders:write',
    batch_hold: 'orders:write',
    batch_remove_order_products: 'orders:write',
    batch_resume: 'orders:write',
    batch_split_fulfillments: 'orders:write',
    batch_update: 'orders:write',
    batch_urgent_order_convert: 'orders:write',
    cancel: 'orders:write',
    close: 'orders:write',
    correct: 'orders:write',
    create: 'orders:write',
    destroy: 'orders:write',
    download_pdf: 'orders:write',
    duplicate: 'orders:write',
    edit: 'orders:read',
    export: 'orders:export',
    finalize_draft: 'orders:write',
    generate_pdf: 'orders:write',
    get_ids: 'orders:read',
    get_records: 'orders:read',
    hold: 'orders:write',
    import: 'orders:write',
    index: 'orders:read',
    integration_log_slice: 'orders:read',
    integration_logs: 'orders:read',
    new: 'orders:read',
    out_of_stock_product_orders: 'orders:read',
    out_of_stock_products: 'orders:read',
    out_of_stock_products_all: 'orders:read',
    postpone: 'orders:write',
    recheck_stock: 'orders:write',
    recording_sessions: 'orders:read',
    release_holds: 'orders:write',
    resume: 'orders:write',
    show: 'orders:read',
    suggest_name: 'orders:read',
    update: 'orders:write',
    upload_label: 'orders:write',
    validate_fulfillment_names: 'orders:read',
    videos: 'orders:read',
  },
  'api/admin/v1/partner_api_logs': {
    get_records: 'logs:read',
    index: 'logs:read',
    show: 'logs:read',
  },
  'api/admin/v1/permission_templates': {
    create: 'users:write',
    destroy: 'users:write',
    index: 'users:read',
  },
  'api/admin/v1/product_attribute_definitions': {
    create: 'merchants:write',
    destroy: 'merchants:write',
    index: 'open',
    update: 'merchants:write',
  },
  'api/admin/v1/product_categories': {
    index: 'open',
  },
  'api/admin/v1/product_label_templates': {
    create: 'products:write',
    default_template: 'open',
    destroy: 'products:write',
    edit: 'products:read',
    get_records: 'products:read',
    index: 'products:read',
    new: 'products:read',
    show: 'products:read',
    update: 'products:write',
  },
  'api/admin/v1/product_serial_numbers': {
    get_records: 'products:read',
    show: 'products:read',
  },
  'api/admin/v1/production_boms': {
    create: 'products:write',
    destroy: 'products:write',
    export: 'products:export',
    get_ids: 'products:read',
    get_records: 'products:read',
    show: 'products:read',
    update: 'products:write',
  },
  'api/admin/v1/products': {
    batch_update: 'products:write',
    check_sku: 'products:read',
    create: 'products:write',
    destroy: 'products:write',
    edit: 'products:read',
    export: 'products:export',
    generate_label: 'products:read',
    get_ids: 'products:read',
    get_records: 'products:read',
    import: 'products:write',
    in_transit: 'products:read',
    index: 'products:read',
    new: 'products:read',
    preview_replace_sku: 'products:read',
    replace_sku: 'products:read',
    show: 'products:read',
    sluggish_products: 'products:read',
    update: 'products:write',
  },
  'api/admin/v1/products/serial_numbers': {
    get_records: 'products:read',
  },
  'api/admin/v1/purchase_order_attachments': {
    create: 'purchase_orders:write',
    destroy: 'purchase_orders:write',
  },
  'api/admin/v1/purchase_order_comments': {
    create: 'purchase_orders:write',
    destroy: 'purchase_orders:write',
    index: 'purchase_orders:read',
    update: 'purchase_orders:write',
  },
  'api/admin/v1/purchase_order_histories': {
    index: 'purchase_orders:read',
  },
  'api/admin/v1/purchase_order_invoices': {
    cancel: 'purchase_orders:write',
    create: 'purchase_orders:write',
    destroy: 'purchase_orders:write',
    index: 'purchase_orders:read',
    update: 'purchase_orders:write',
  },
  'api/admin/v1/purchase_orders': {
    approve: 'purchase_orders:approve',
    cancel: 'purchase_orders:write',
    close: 'purchase_orders:write',
    create: 'purchase_orders:write',
    create_inbound: 'purchase_orders:write',
    destroy: 'purchase_orders:write',
    edit: 'purchase_orders:read',
    export: 'purchase_orders:export',
    get_ids: 'purchase_orders:read',
    get_records: 'purchase_orders:read',
    index: 'purchase_orders:read',
    new: 'purchase_orders:read',
    reject: 'purchase_orders:approve',
    short_close: 'purchase_orders:write',
    show: 'purchase_orders:read',
    submit: 'purchase_orders:write',
    suggest_name: 'purchase_orders:read',
    update: 'purchase_orders:write',
  },
  'api/admin/v1/recording_sessions': {
    force_finalize: 'orders:write',
  },
  'api/admin/v1/return_orders': {
    cancel: 'return_orders:write',
    create: 'return_orders:write',
    destroy: 'return_orders:write',
    edit: 'return_orders:read',
    export: 'return_orders:export',
    get_ids: 'return_orders:read',
    get_records: 'return_orders:read',
    import: 'return_orders:write',
    index: 'return_orders:read',
    new: 'return_orders:read',
    resume: 'return_orders:write',
    show: 'return_orders:read',
    update: 'return_orders:write',
    videos: 'return_orders:read',
  },
  'api/admin/v1/return_receipts': {
    show: 'return_orders:read',
  },
  'api/admin/v1/sales_channels': {
    create: 'merchants:write',
    get_ids: 'open',
    get_records: 'open',
    index: 'open',
    show: 'open',
    update: 'merchants:write',
  },
  'api/admin/v1/sessions': {
    get_permissions: 'open',
  },
  'api/admin/v1/settings': {
    show: 'open',
    update: 'merchants:write',
  },
  'api/admin/v1/shelf_movements': {
    export: 'shelves:export',
    get_ids: 'shelves:read',
    get_records: 'shelves:read',
  },
  'api/admin/v1/shelf_types': {
    index: 'open',
  },
  'api/admin/v1/shelves': {
    get_ids: 'shelves:read',
    get_records: 'shelves:read',
    index: 'shelves:read',
    show: 'shelves:read',
  },
  'api/admin/v1/shipments': {
    create: 'orders:write',
    destroy: 'orders:write',
    edit: 'orders:read',
    execute_html_url: 'orders:read',
    export: 'orders:export',
    get_ids: 'orders:read',
    get_records: 'orders:read',
    index: 'orders:read',
    new: 'orders:read',
    restore: 'orders:write',
    show: 'orders:read',
    update: 'orders:write',
  },
  'api/admin/v1/shipping_accounts': {
    create: 'shipping_accounts:write',
    destroy: 'shipping_accounts:write',
    disable: 'shipping_accounts:write',
    get_records: 'shipping_accounts:read',
    index: 'shipping_accounts:read',
    show: 'shipping_accounts:read',
    update: 'shipping_accounts:write',
  },
  'api/admin/v1/shipping_types': {
    catalog: 'open',
    index: 'open',
  },
  'api/admin/v1/stock_adjustments': {
    get_records: 'inventories:read',
    show: 'inventories:read',
  },
  'api/admin/v1/stock_takings': {
    create: 'inventories:write',
    destroy: 'inventories:write',
    edit: 'inventories:read',
    export: 'inventories:export',
    get_ids: 'inventories:read',
    get_records: 'inventories:read',
    index: 'inventories:read',
    items: 'inventories:read',
    new: 'inventories:read',
    show: 'inventories:read',
    update: 'inventories:write',
  },
  'api/admin/v1/stock_transfer_orders': {
    get_ids: 'inventories:read',
    get_records: 'inventories:read',
    show: 'inventories:read',
  },
  'api/admin/v1/suppliers': {
    create: 'suppliers:write',
    destroy: 'suppliers:write',
    edit: 'suppliers:read',
    get_ids: 'suppliers:read',
    get_records: 'suppliers:read',
    index: 'suppliers:read',
    new: 'suppliers:read',
    show: 'suppliers:read',
    update: 'suppliers:write',
  },
  'api/admin/v1/test_jobs': {
    create: 'open',
  },
  'api/admin/v1/third_party_api_logs': {
    get_records: 'logs:read',
    index: 'logs:read',
    show: 'logs:read',
  },
  'api/admin/v1/unknown_products': {
    get_records: 'products:read',
    index: 'products:read',
    map_to: 'products:write',
    show: 'products:read',
  },
  'api/admin/v1/user_invitations': {
    create: 'users:write',
    destroy: 'users:write',
    index: 'users:read',
    regenerate: 'users:write',
  },
  'api/admin/v1/user_menus': {
    batch_update: 'open',
    index: 'open',
    reset: 'open',
    toggle_pin: 'open',
  },
  'api/admin/v1/users': {
    disable: 'users:write',
    enable: 'users:write',
    get_records: 'users:read',
    index: 'users:read',
    reset_totp: 'users:write',
    show: 'open',
    update: 'open',
    update_password: 'open',
    update_permissions: 'users:write',
  },
  'api/admin/v1/webhook_deliveries': {
    get_records: 'logs:read',
    index: 'logs:read',
    retry: 'logs:read',
    show: 'logs:read',
  },
  'api/admin/v1/webhooks': {
    available_events: 'open',
    create: 'webhooks:write',
    destroy: 'webhooks:write',
    edit: 'webhooks:read',
    get_records: 'webhooks:read',
    index: 'webhooks:read',
    new: 'webhooks:read',
    regenerate_secret: 'webhooks:write',
    show: 'webhooks:read',
    test: 'webhooks:read',
    toggle_active: 'webhooks:write',
    update: 'webhooks:write',
  },
  'api/admin/v1/workflows': {
    ai_chat: 'open',
    create: 'open',
    destroy: 'open',
    index: 'open',
    show: 'open',
    update: 'open',
  },
  'api/app/v1/broadcasts': {
    index: 'open',
    unread_count: 'open',
  },
  'api/app/v1/devices': {
    create: 'open',
    unregister: 'open',
  },
  'api/app/v1/fulfillments': {
    complete: 'open',
    qc_info: 'open',
    show: 'open',
    takeover_packing: 'open',
  },
  'api/app/v1/inbound_items': {
    show: 'open',
  },
  'api/app/v1/inbounds': {
    add_item: 'open',
    close_receiving: 'open',
    count: 'open',
    index: 'open',
    receive: 'open',
    reopen: 'open',
    show: 'open',
    start_new_receipt: 'open',
    verify_all: 'open',
  },
  'api/app/v1/merchants': {
    index: 'open',
    inventory_types: 'open',
    set_merchants: 'open',
  },
  'api/app/v1/picking_list_items': {
    pick: 'open',
  },
  'api/app/v1/picking_lists': {
    count: 'open',
    index: 'open',
    put_back: 'open',
    reopen: 'open',
    show: 'open',
    tote_items: 'open',
  },
  'api/app/v1/products': {
    inventory: 'open',
    movements: 'open',
    show: 'open',
    show_by_barcode: 'open',
    update: 'open',
  },
  'api/app/v1/receipt_items': {
    batch_putaway: 'open',
    batch_receive: 'open',
    destroy: 'open',
    recommend: 'open',
    shelf_movements: 'open',
  },
  'api/app/v1/receipts': {
    count: 'open',
    create: 'open',
    finalize: 'open',
    index: 'open',
    show: 'open',
  },
  'api/app/v1/replenishment_orders': {
    cancel: 'open',
    close: 'open',
    execute_item: 'open',
    index: 'open',
    show: 'open',
  },
  'api/app/v1/sessions': {
    create: 'open',
    destroy: 'open',
    show: 'open',
    verify_totp: 'open',
  },
  'api/app/v1/shelves': {
    inventories: 'open',
    relocate: 'open',
    show: 'open',
    validate_location: 'open',
  },
  'api/app/v1/stock_adjustments': {
    create: 'open',
    index: 'open',
  },
  'api/app/v1/stock_taking_shelves': {
    confirm: 'open',
    index: 'open',
    show: 'open',
  },
  'api/app/v1/stock_takings': {
    count: 'open',
    discrepancies: 'open',
    index: 'open',
    show: 'open',
  },
  'api/operator/v1/accessible_ip_addresses': {
    batch_delete: 'accessible_ip_addresses:write',
    create: 'accessible_ip_addresses:write',
    current_ip: 'accessible_ip_addresses:read',
    destroy: 'accessible_ip_addresses:write',
    index: 'accessible_ip_addresses:read',
    show: 'accessible_ip_addresses:read',
  },
  'api/operator/v1/background_jobs': {
    batch_status: 'open',
    cancel: 'open',
  },
  'api/operator/v1/billings': {
    add_item: 'merchants:write',
    get_ids: 'open',
    get_records: 'open',
    show: 'open',
    update_status: 'merchants:write',
  },
  'api/operator/v1/brands': {
    create: 'brands:write',
    destroy: 'brands:write',
    get_ids: 'open',
    get_records: 'open',
    index: 'open',
    show: 'open',
    update: 'brands:write',
  },
  'api/operator/v1/bundles': {
    create: 'products:write',
    export: 'products:export',
    get_ids: 'products:read',
    get_records: 'products:read',
    import: 'products:write',
    index: 'products:read',
    show: 'products:read',
    update: 'products:write',
  },
  'api/operator/v1/consumables': {
    check_barcode: 'consumables:read',
    create: 'consumables:write',
    destroy: 'consumables:write',
    edit: 'consumables:read',
    export: 'consumables:export',
    get_ids: 'consumables:read',
    get_records: 'consumables:read',
    index: 'consumables:read',
    new: 'consumables:read',
    show: 'consumables:read',
    update: 'consumables:write',
  },
  'api/operator/v1/contact_addresses': {
    create: 'contact_addresses:write',
    destroy: 'contact_addresses:write',
    edit: 'contact_addresses:read',
    export: 'contact_addresses:export',
    get_ids: 'contact_addresses:read',
    get_records: 'contact_addresses:read',
    import: 'contact_addresses:write',
    index: 'contact_addresses:read',
    new: 'contact_addresses:read',
    show: 'contact_addresses:read',
    update: 'contact_addresses:write',
  },
  'api/operator/v1/currencies': {
    index: 'open',
  },
  'api/operator/v1/dashboard': {
    held_orders: 'open',
    pending_orders: 'open',
    settings: 'open',
    sla_overview: 'open',
    update_settings: 'open',
  },
  'api/operator/v1/ec_accounts': {
    coupang_shipping_info: 'ec_accounts:read',
    create: 'ec_accounts:write',
    destroy: 'ec_accounts:write',
    edit: 'ec_accounts:read',
    get_records: 'ec_accounts:read',
    index: 'ec_accounts:read',
    new: 'ec_accounts:read',
    schedule_fetch: 'ec_accounts:write',
    shopee_revoke: 'ec_accounts:write',
    shopify_revoke: 'ec_accounts:read',
    show: 'ec_accounts:read',
    sync_product_mappings: 'ec_accounts:write',
    sync_stock: 'ec_accounts:write',
    test_connection: 'ec_accounts:write',
    update: 'ec_accounts:write',
  },
  'api/operator/v1/exception_dashboard': {
    exceptions: 'open',
  },
  'api/operator/v1/flexible_products': {
    create: 'products:write',
    destroy: 'products:write',
    get_ids: 'products:read',
    get_records: 'products:read',
    index: 'products:read',
    show: 'products:read',
    update: 'products:write',
  },
  'api/operator/v1/fulfillment_dashboard': {
    carrier_progress: 'open',
    fulfillment_progress: 'open',
  },
  'api/operator/v1/fulfillments': {
    change_shipping_type: 'orders:write',
    complete: 'orders:write',
    complete_qc: 'orders:write',
    get_ids: 'orders:read',
    get_records: 'orders:read',
    held_count: 'orders:read',
    index: 'orders:read',
    log_action: 'orders:write',
    merge: 'orders:write',
    mergeable_groups: 'orders:read',
    pack: 'orders:write',
    print_label: 'orders:write',
    qc_info: 'orders:write',
    recording_sessions: 'orders:read',
    scan: 'orders:read',
    show: 'orders:read',
    split: 'orders:write',
    split_preview: 'orders:read',
    takeover_packing: 'orders:write',
    upload_video: 'orders:write',
    videos: 'orders:read',
  },
  'api/operator/v1/governance/accounts': {
    reactivate: 'governance:write',
    reactivation_preview: 'governance:read',
  },
  'api/operator/v1/governance/ai_credit_purchases': {
    create: 'governance:write',
    index: 'governance:read',
    packs: 'governance:read',
  },
  'api/operator/v1/governance/ai_wallet': {
    consume: 'governance:write',
    show: 'governance:read',
    update_daily_budget: 'governance:write',
  },
  'api/operator/v1/governance/billing_profiles': {
    show: 'governance:read',
    update: 'governance:write',
  },
  'api/operator/v1/governance/invoices': {
    cancel: 'governance:write',
    checkout: 'governance:read',
    index: 'governance:read',
    notify_payment: 'governance:read',
    pay: 'governance:write',
    show: 'governance:read',
  },
  'api/operator/v1/governance/payment_methods': {
    bind_card: 'governance:write',
    create: 'governance:write',
    destroy: 'governance:write',
    index: 'governance:read',
    sdk_token: 'governance:write',
    set_default: 'governance:write',
  },
  'api/operator/v1/governance/pcs_ledger_entries': {
    export: 'governance:export',
    index: 'governance:read',
    summary: 'governance:read',
  },
  'api/operator/v1/governance/pricing_plans': {
    index: 'open',
    show: 'open',
  },
  'api/operator/v1/governance/subscriptions': {
    addon_options: 'governance:read',
    addons: 'governance:read',
    cancel: 'governance:write',
    cancel_addon: 'governance:read',
    cancel_pending_change: 'governance:read',
    change_billing_cycle: 'governance:read',
    downgrade: 'governance:read',
    preview_change: 'governance:read',
    purchase_addon: 'governance:read',
    reactivate: 'governance:write',
    reduce_addon: 'governance:read',
    revert_billing_cycle_upgrade: 'governance:read',
    sales_referral_code: 'governance:read',
    show: 'governance:read',
    subscribe: 'governance:read',
    update: 'governance:write',
    upgrade: 'governance:read',
  },
  'api/operator/v1/governance/usage_records': {
    index: 'governance:read',
    summary: 'governance:read',
  },
  'api/operator/v1/holidays': {
    create: 'organizations:write',
    destroy: 'organizations:write',
    edit: 'organizations:write',
    index: 'open',
    new: 'organizations:write',
    show: 'open',
    update: 'organizations:write',
  },
  'api/operator/v1/import_templates': {
    download: 'open',
  },
  'api/operator/v1/imports': {
    get_records: 'products:read',
    imported_orders: 'products:read',
    show: 'products:read',
  },
  'api/operator/v1/inbound_dashboard': {
    inbound_progress: 'open',
  },
  'api/operator/v1/inbound_value_added_services': {
    create: 'billings:write',
    destroy: 'billings:write',
    update: 'billings:write',
  },
  'api/operator/v1/inbounds': {
    cancel: 'inbounds:write',
    close_receiving: 'inbounds:write',
    create: 'inbounds:write',
    destroy: 'inbounds:write',
    edit: 'inbounds:read',
    export: 'inbounds:export',
    generate_labels: 'inbounds:read',
    generate_pdf: 'inbounds:read',
    get_ids: 'inbounds:read',
    get_records: 'inbounds:read',
    import: 'inbounds:write',
    index: 'inbounds:read',
    new: 'inbounds:read',
    resume: 'inbounds:write',
    serial_numbers_get_records: 'inbounds:read',
    show: 'inbounds:read',
    start_new_receipt: 'inbounds:write',
    suggest_name: 'inbounds:read',
    update: 'inbounds:write',
  },
  'api/operator/v1/inventories': {
    allocations: 'inventories:read',
    export: 'inventories:export',
    get_ids: 'inventories:read',
    get_records: 'inventories:read',
    index: 'inventories:read',
    orders: 'inventories:read',
    shelf_inventories: 'inventories:read',
  },
  'api/operator/v1/inventory_attribute_definitions': {
    index: 'open',
  },
  'api/operator/v1/inventory_holds': {
    batch_release: 'inventories:write',
    create: 'inventories:write',
    get_records: 'inventories:read',
    show: 'inventories:read',
  },
  'api/operator/v1/inventory_monitors': {
    batch_delete: 'inventories:write',
    create: 'inventories:write',
    destroy: 'inventories:write',
    export_insufficient: 'inventories:export',
    get_ids: 'inventories:read',
    get_records: 'inventories:read',
    show: 'inventories:read',
    toggle_alert: 'inventories:write',
    update: 'inventories:write',
  },
  'api/operator/v1/inventory_movements': {
    export: 'inventories:export',
    get_ids: 'inventories:read',
    get_records: 'inventories:read',
  },
  'api/operator/v1/inventory_shelves': {
    get_records: 'inventories:read',
    index: 'inventories:read',
  },
  'api/operator/v1/inventory_snapshots': {
    export: 'inventories:export',
    get_ids: 'inventories:read',
    get_records: 'inventories:read',
  },
  'api/operator/v1/inventory_transformations': {
    approve: 'inventories:approve',
    create: 'inventories:write',
    get_records: 'inventories:read',
    reject: 'inventories:approve',
    show: 'inventories:read',
    suggest_name: 'inventories:read',
    update: 'inventories:write',
  },
  'api/operator/v1/inventory_type_reclassify_rules': {
    get_records: 'inventories:read',
    index: 'inventories:read',
    show: 'inventories:read',
  },
  'api/operator/v1/inventory_types': {
    create: 'merchants:write',
    index: 'open',
    list_all: 'open',
    update: 'merchants:write',
  },
  'api/operator/v1/invoice_payments': {
    create: 'purchase_orders:write',
    destroy: 'purchase_orders:write',
  },
  'api/operator/v1/location_snapshots': {
    export: 'inventories:export',
    summary: 'inventories:read',
  },
  'api/operator/v1/menus': {
    index: 'open',
  },
  'api/operator/v1/merchant_inventory_types': {
    create: 'merchants:write',
    destroy: 'merchants:write',
    index: 'open',
    update: 'merchants:write',
  },
  'api/operator/v1/merchant_shipping_types': {
    create: 'merchants:write',
    destroy: 'merchants:write',
    index: 'open',
    update: 'merchants:write',
  },
  'api/operator/v1/merchant_sla_settings': {
    backfill: 'merchants:write',
    show: 'open',
    update: 'merchants:write',
  },
  'api/operator/v1/merchants': {
    create: 'merchants:write',
    get_ids: 'open',
    get_records: 'open',
    index: 'open',
    list_all: 'open',
    show: 'open',
    update: 'merchants:write',
    update_order_item_columns: 'merchants:write',
  },
  'api/operator/v1/notification_subscriptions': {
    show: 'open',
    update: 'open',
  },
  'api/operator/v1/notifications': {
    get_ids: 'open',
    get_records: 'open',
    index: 'open',
    read_all: 'open',
    set_read: 'open',
    show: 'open',
    unread_count: 'open',
  },
  'api/operator/v1/onboarding/completions': {
    create: 'open',
  },
  'api/operator/v1/operator_invitations': {
    create: 'operators:write',
    destroy: 'operators:write',
    index: 'operators:read',
    regenerate: 'operators:write',
  },
  'api/operator/v1/operator_menus': {
    batch_update: 'open',
    index: 'open',
    reset: 'open',
    toggle_pin: 'open',
  },
  'api/operator/v1/operators': {
    create: 'operators:write',
    disable: 'operators:write',
    enable: 'operators:write',
    get_info: 'open',
    get_records: 'operators:read',
    index: 'operators:read',
    reset_totp: 'operators:write',
    show: 'open',
    update: 'open',
    update_merchants: 'open',
    update_password: 'open',
    update_permissions: 'operators:write',
  },
  'api/operator/v1/order_attachments': {
    create: 'orders:write',
    destroy: 'orders:write',
  },
  'api/operator/v1/order_holds': {
    batch_release: 'orders:write',
    get_records: 'orders:read',
  },
  'api/operator/v1/order_serial_numbers': {
    get_records: 'orders:read',
    index: 'orders:read',
  },
  'api/operator/v1/order_templates': {
    ai_chat: 'orders:write',
    analyze_pdf: 'orders:write',
    create: 'orders:write',
    default_template: 'open',
    destroy: 'orders:write',
    edit: 'orders:read',
    get_records: 'orders:read',
    index: 'orders:read',
    new: 'orders:read',
    sample_reserved_barcode_area: 'open',
    show: 'orders:read',
    update: 'orders:write',
  },
  'api/operator/v1/order_value_added_services': {
    create: 'billings:write',
    destroy: 'billings:write',
    update: 'billings:write',
  },
  'api/operator/v1/orders': {
    batch_cancel: 'orders:write',
    batch_check: 'orders:write',
    batch_convert_to_draft_order: 'orders:write',
    batch_convert_to_urgent_order: 'orders:write',
    batch_create_return_order: 'orders:write',
    batch_draft_order_convert: 'orders:write',
    batch_hold: 'orders:write',
    batch_remove_order_products: 'orders:write',
    batch_resume: 'orders:write',
    batch_split_fulfillments: 'orders:write',
    batch_update: 'orders:write',
    batch_urgent_order_convert: 'orders:write',
    bind_ec_account: 'orders:write',
    cancel: 'orders:write',
    close: 'orders:write',
    confirm: 'orders:write',
    correct: 'orders:write',
    create: 'orders:write',
    download_pdf: 'orders:write',
    duplicate: 'orders:write',
    export: 'orders:export',
    finalize_draft: 'orders:write',
    generate_pdf: 'orders:write',
    get_ids: 'orders:read',
    get_records: 'orders:read',
    hold: 'orders:write',
    import: 'orders:write',
    index: 'orders:read',
    integration_log_slice: 'orders:read',
    integration_logs: 'orders:read',
    log_action: 'orders:write',
    out_of_stock_product_orders: 'orders:read',
    out_of_stock_products: 'orders:read',
    out_of_stock_products_all: 'orders:read',
    pack: 'orders:write',
    postpone: 'orders:write',
    qc_info: 'orders:write',
    recheck_stock: 'orders:write',
    recording_sessions: 'orders:read',
    release_holds: 'orders:write',
    resume: 'orders:write',
    search: 'orders:read',
    show: 'orders:read',
    suggest_name: 'orders:read',
    test_import: 'orders:write',
    update: 'orders:write',
    upload_label: 'orders:write',
    validate_fulfillment_names: 'orders:read',
    videos: 'orders:read',
  },
  'api/operator/v1/organizations': {
    merchants: 'organizations:read',
    settings: 'organizations:read',
    update_settings: 'organizations:write',
  },
  'api/operator/v1/parcels': {
    destroy: 'orders:write',
    update: 'orders:write',
  },
  'api/operator/v1/partner_api_logs': {
    get_records: 'logs:read',
    index: 'logs:read',
  },
  'api/operator/v1/pdf_tools': {
    decrypt: 'open',
  },
  'api/operator/v1/permission_templates': {
    create: 'operators:write',
    destroy: 'operators:write',
    index: 'operators:read',
  },
  'api/operator/v1/picking_dashboard': {
    picking_progress: 'open',
  },
  'api/operator/v1/picking_list_presets': {
    create: 'orders:write',
    destroy: 'orders:write',
    edit: 'orders:read',
    index: 'orders:read',
    new: 'orders:read',
    show: 'orders:read',
    simulate: 'orders:read',
    update: 'orders:write',
  },
  'api/operator/v1/picking_lists': {
    confirm: 'orders:write',
    create: 'orders:write',
    download_attachments: 'orders:read',
    export: 'orders:export',
    export_pick_history: 'orders:export',
    generate_pdf: 'orders:write',
    generate_wave_fulfillment_pdf: 'orders:write',
    get_records: 'orders:read',
    put_back_tote: 'orders:read',
    reopen: 'orders:write',
    residual_totes: 'orders:read',
    show: 'orders:read',
    tote_items: 'orders:read',
  },
  'api/operator/v1/picking_movements': {
    get_records: 'orders:read',
  },
  'api/operator/v1/picking_waves': {
    abort_wave: 'orders:read',
    batch_download_labels: 'orders:write',
    batch_request_tracking_numbers: 'orders:write',
    batch_return_fulfillments: 'orders:write',
    clear_distribute_events: 'orders:write',
    download_attachments: 'orders:read',
    download_to_label: 'orders:write',
    fulfillment_tote_status: 'orders:read',
    generate_fulfillment_pdf: 'orders:write',
    print: 'orders:write',
    resolve: 'orders:read',
    return_fulfillment: 'orders:write',
    scan_barcode: 'orders:write',
    show: 'orders:read',
    toggle_exception_mode: 'orders:write',
  },
  'api/operator/v1/product_attribute_definitions': {
    index: 'open',
  },
  'api/operator/v1/product_categories': {
    create: 'products:write',
    destroy: 'products:write',
    get_ids: 'open',
    get_records: 'open',
    index: 'open',
    show: 'open',
    update: 'products:write',
  },
  'api/operator/v1/product_label_templates': {
    create: 'products:write',
    default_template: 'open',
    destroy: 'products:write',
    edit: 'products:read',
    get_records: 'products:read',
    index: 'products:read',
    new: 'products:read',
    show: 'products:read',
    update: 'products:write',
  },
  'api/operator/v1/product_replenishment_shelves': {
    create: 'inventories:write',
    destroy: 'inventories:write',
    get_records: 'inventories:read',
    index: 'inventories:read',
    show: 'inventories:read',
    update: 'inventories:write',
  },
  'api/operator/v1/product_serial_numbers': {
    get_records: 'products:read',
    show: 'products:read',
  },
  'api/operator/v1/production_boms': {
    create: 'products:write',
    destroy: 'products:write',
    export: 'products:export',
    get_ids: 'products:read',
    get_records: 'products:read',
    index: 'products:read',
    show: 'products:read',
    update: 'products:write',
  },
  'api/operator/v1/products': {
    batch_update: 'products:write',
    check_sku: 'products:read',
    create: 'products:write',
    destroy: 'products:write',
    edit: 'products:read',
    export: 'products:export',
    generate_label: 'products:read',
    get_ids: 'products:read',
    get_records: 'products:read',
    import: 'products:write',
    in_transit: 'products:read',
    index: 'products:read',
    new: 'products:read',
    preview_replace_sku: 'products:read',
    replace_sku: 'products:read',
    show: 'products:read',
    sluggish_products: 'products:read',
    update: 'products:write',
  },
  'api/operator/v1/products/serial_numbers': {
    get_records: 'products:read',
  },
  'api/operator/v1/purchase_order_attachments': {
    create: 'purchase_orders:write',
    destroy: 'purchase_orders:write',
  },
  'api/operator/v1/purchase_order_comments': {
    create: 'purchase_orders:write',
    destroy: 'purchase_orders:write',
    index: 'purchase_orders:read',
    update: 'purchase_orders:write',
  },
  'api/operator/v1/purchase_order_histories': {
    index: 'purchase_orders:read',
  },
  'api/operator/v1/purchase_order_invoices': {
    cancel: 'purchase_orders:write',
    create: 'purchase_orders:write',
    destroy: 'purchase_orders:write',
    index: 'purchase_orders:read',
    update: 'purchase_orders:write',
  },
  'api/operator/v1/purchase_orders': {
    approve: 'purchase_orders:approve',
    cancel: 'purchase_orders:write',
    close: 'purchase_orders:write',
    create: 'purchase_orders:write',
    create_inbound: 'purchase_orders:write',
    destroy: 'purchase_orders:write',
    edit: 'purchase_orders:read',
    export: 'purchase_orders:export',
    get_ids: 'purchase_orders:read',
    get_records: 'purchase_orders:read',
    index: 'purchase_orders:read',
    new: 'purchase_orders:read',
    reject: 'purchase_orders:approve',
    short_close: 'purchase_orders:write',
    show: 'purchase_orders:read',
    submit: 'purchase_orders:write',
    suggest_name: 'purchase_orders:read',
    update: 'purchase_orders:write',
  },
  'api/operator/v1/rate_cards': {
    create: 'merchants:write',
    current: 'open',
    destroy: 'merchants:write',
    index: 'open',
    preview: 'open',
    show: 'open',
    update: 'merchants:write',
  },
  'api/operator/v1/receipt_items': {
    batch_putaway: 'inbounds:write',
    batch_receive: 'inbounds:write',
    create_unplanned: 'inbounds:write',
    destroy: 'inbounds:write',
    recommend: 'inbounds:read',
  },
  'api/operator/v1/receipts': {
    auto_putaway: 'inbounds:write',
    create: 'inbounds:write',
    finalize: 'inbounds:write',
    show: 'inbounds:read',
  },
  'api/operator/v1/recording_chunks': {
    sign: 'orders:write',
  },
  'api/operator/v1/recording_sessions': {
    finalize: 'orders:write',
    force_finalize: 'orders:write',
  },
  'api/operator/v1/replenishment_needs': {
    index: 'inventories:read',
  },
  'api/operator/v1/replenishment_orders': {
    cancel: 'inventories:write',
    close: 'inventories:write',
    generate: 'inventories:write',
    get_records: 'inventories:read',
    index: 'inventories:read',
    preview: 'inventories:read',
    show: 'inventories:read',
  },
  'api/operator/v1/reports': {
    orders_statistics: 'reports:read',
    product_affinities: 'reports:read',
  },
  'api/operator/v1/return_orders': {
    cancel: 'return_orders:write',
    create: 'return_orders:write',
    create_from_fulfillment: 'return_orders:write',
    destroy: 'return_orders:write',
    edit: 'return_orders:read',
    export: 'return_orders:export',
    finalize_receive: 'return_orders:write',
    get_ids: 'return_orders:read',
    get_records: 'return_orders:read',
    import: 'return_orders:write',
    index: 'return_orders:read',
    new: 'return_orders:read',
    resume: 'return_orders:write',
    search: 'return_orders:read',
    serial_numbers_get_records: 'return_orders:read',
    show: 'return_orders:read',
    suggest_name: 'return_orders:read',
    unfinalize_receive: 'return_orders:write',
    update: 'return_orders:write',
    videos: 'return_orders:read',
  },
  'api/operator/v1/return_receipt_recording_chunks': {
    sign: 'return_orders:write',
  },
  'api/operator/v1/return_receipt_recording_sessions': {
    finalize: 'return_orders:write',
  },
  'api/operator/v1/return_receipts': {
    cancel: 'return_orders:write',
    convert_to_inbound: 'return_orders:write',
    create: 'return_orders:write',
    destroy: 'return_orders:write',
    edit: 'return_orders:read',
    get_ids: 'return_orders:read',
    get_records: 'return_orders:read',
    index: 'return_orders:read',
    init_draft: 'return_orders:write',
    new: 'return_orders:read',
    reopen: 'return_orders:write',
    save_progress: 'return_orders:write',
    search: 'return_orders:read',
    serial_numbers_get_records: 'return_orders:read',
    show: 'return_orders:read',
    update: 'return_orders:write',
    verify: 'return_orders:write',
  },
  'api/operator/v1/sales_channels': {
    create: 'merchants:write',
    get_ids: 'open',
    get_records: 'open',
    index: 'open',
    show: 'open',
    update: 'merchants:write',
  },
  'api/operator/v1/sessions': {
    create: 'open',
    destroy: 'open',
    quick_login: 'open',
    show: 'open',
    verify_totp: 'open',
  },
  'api/operator/v1/shelf_movements': {
    export: 'shelves:export',
    get_ids: 'shelves:read',
    get_records: 'shelves:read',
  },
  'api/operator/v1/shelf_types': {
    create: 'organizations:write',
    destroy: 'organizations:write',
    index: 'open',
    list_all: 'open',
    show: 'open',
    update: 'warehouses:write',
  },
  'api/operator/v1/shelves': {
    batch_create: 'shelves:write',
    batch_delete: 'shelves:write',
    generate_barcodes: 'shelves:write',
    get_ids: 'shelves:read',
    get_records: 'shelves:read',
    index: 'shelves:read',
    list_all: 'shelves:read',
    preview_batch_create: 'shelves:read',
    show: 'shelves:read',
    update: 'shelves:write',
    update_default_template: 'shelves:write',
    validate_location: 'shelves:read',
  },
  'api/operator/v1/shipments': {
    create: 'orders:write',
    destroy: 'orders:write',
    edit: 'orders:read',
    execute_html_url: 'orders:read',
    export: 'orders:export',
    get_ids: 'orders:read',
    get_records: 'orders:read',
    index: 'orders:read',
    new: 'orders:read',
    restore: 'orders:write',
    show: 'orders:read',
    test_print_label: 'orders:write',
    update: 'orders:write',
  },
  'api/operator/v1/shipping_accounts': {
    create: 'shipping_accounts:write',
    destroy: 'shipping_accounts:write',
    disable: 'shipping_accounts:write',
    get_records: 'shipping_accounts:read',
    index: 'shipping_accounts:read',
    show: 'shipping_accounts:read',
    update: 'shipping_accounts:write',
  },
  'api/operator/v1/shipping_rate_cards': {
    create: 'merchants:write',
    destroy: 'merchants:write',
    edit: 'open',
    index: 'open',
    new: 'open',
    show: 'open',
    update: 'merchants:write',
  },
  'api/operator/v1/shipping_types': {
    activate: 'organizations:write',
    catalog: 'open',
    create: 'organizations:write',
    deactivate: 'organizations:write',
    index: 'open',
    list_all: 'open',
    update: 'organizations:write',
  },
  'api/operator/v1/stock_adjustments': {
    approve: 'inventories:approve',
    create: 'inventories:write',
    get_records: 'inventories:read',
    import: 'inventories:write',
    preview_approve: 'inventories:read',
    reject: 'inventories:approve',
    show: 'inventories:read',
    suggest_name: 'inventories:read',
    update: 'inventories:write',
  },
  'api/operator/v1/stock_taking_shelves': {
    confirm: 'inventories:write',
    index: 'inventories:read',
    items: 'inventories:read',
    show: 'inventories:read',
  },
  'api/operator/v1/stock_takings': {
    approve: 'inventories:approve',
    batch_create: 'inventories:write',
    batch_update_items: 'inventories:write',
    confirm_all_shelves: 'inventories:write',
    create: 'inventories:write',
    destroy: 'inventories:write',
    edit: 'inventories:read',
    export: 'inventories:export',
    export_items: 'inventories:export',
    generate_for_virtual: 'inventories:write',
    get_ids: 'inventories:read',
    get_records: 'inventories:read',
    import_items: 'inventories:write',
    index: 'inventories:read',
    item_count_entries: 'inventories:read',
    items: 'inventories:read',
    new: 'inventories:read',
    preview_approve: 'inventories:read',
    preview_split: 'inventories:read',
    reject: 'inventories:approve',
    show: 'inventories:read',
    suggest_name: 'inventories:read',
    update: 'inventories:write',
    virtual_preview: 'inventories:read',
    zero_out_uncounted: 'inventories:write',
  },
  'api/operator/v1/stock_transfer_orders': {
    cancel: 'inventories:write',
    create: 'inventories:write',
    destroy: 'inventories:write',
    edit: 'inventories:read',
    get_ids: 'inventories:read',
    get_records: 'inventories:read',
    index: 'inventories:read',
    new: 'inventories:read',
    reopen: 'inventories:write',
    show: 'inventories:read',
    suggest_name: 'inventories:read',
    update: 'inventories:write',
  },
  'api/operator/v1/suppliers': {
    create: 'suppliers:write',
    destroy: 'suppliers:write',
    edit: 'suppliers:read',
    get_ids: 'suppliers:read',
    get_records: 'suppliers:read',
    index: 'suppliers:read',
    new: 'suppliers:read',
    show: 'suppliers:read',
    update: 'suppliers:write',
  },
  'api/operator/v1/test_jobs': {
    create: 'open',
  },
  'api/operator/v1/third_party_api_logs': {
    get_records: 'logs:read',
    index: 'logs:read',
    show: 'logs:read',
  },
  'api/operator/v1/totp': {
    disable: 'open',
    enable: 'open',
    regenerate_backup_codes: 'open',
    setup: 'open',
    status: 'open',
  },
  'api/operator/v1/unknown_products': {
    get_records: 'products:read',
    index: 'products:read',
    map_to: 'products:write',
    show: 'products:read',
  },
  'api/operator/v1/user_invitations': {
    create: 'users:write',
    destroy: 'users:write',
    index: 'users:read',
    regenerate: 'users:write',
  },
  'api/operator/v1/value_added_services': {
    create: 'billings:write',
    destroy: 'billings:write',
    get_ids: 'billings:read',
    get_records: 'billings:read',
    index: 'billings:read',
    show: 'billings:read',
    update: 'billings:write',
  },
  'api/operator/v1/warehouse_broadcasts': {
    assignees: 'open',
    create: 'warehouses:write',
    get_records: 'open',
    index: 'open',
  },
  'api/operator/v1/warehouse_zones': {
    create: 'warehouses:write',
    destroy: 'warehouses:write',
    index: 'open',
    update: 'warehouses:write',
  },
  'api/operator/v1/warehouses': {
    create: 'warehouses:write',
    get_ids: 'open',
    get_records: 'open',
    index: 'open',
    list_all_merchants: 'open',
    merchant_ids: 'open',
    show: 'open',
    update: 'warehouses:write',
  },
  'api/operator/v1/webhook_deliveries': {
    get_records: 'logs:read',
    index: 'logs:read',
    retry: 'logs:read',
    show: 'logs:read',
  },
  'api/operator/v1/work_orders': {
    complete: 'work_orders:write',
    confirm: 'work_orders:write',
    create: 'work_orders:write',
    create_picking_list: 'work_orders:write',
    destroy: 'work_orders:write',
    edit: 'work_orders:read',
    get_ids: 'work_orders:read',
    get_records: 'work_orders:read',
    index: 'work_orders:read',
    new: 'work_orders:read',
    show: 'work_orders:read',
    suggest_name: 'work_orders:read',
    update: 'work_orders:write',
  },
  'api/operator/v1/workforce_stats': {
    daily_summary: 'operators:read',
    operator_performance: 'operators:read',
    operators_overview: 'operators:read',
  },
} as const;

export type ControllerPath = keyof typeof PERMISSION_MANIFEST;

export const RESOURCES: readonly string[] = [
  'accessible_ip_addresses',
  'billings',
  'brands',
  'consumables',
  'contact_addresses',
  'ec_accounts',
  'governance',
  'inbounds',
  'integrations',
  'inventories',
  'inventory_transformations',
  'inventory_type_reclassify_rules',
  'logs',
  'merchants',
  'operators',
  'orders',
  'organizations',
  'products',
  'purchase_orders',
  'reports',
  'return_orders',
  'shelves',
  'shipping_accounts',
  'suppliers',
  'users',
  'warehouses',
  'webhooks',
  'work_orders',
] as const;

export const RESOURCE_ACTIONS: Readonly<Record<string, readonly string[]>> = {
  'accessible_ip_addresses': ['read', 'write'],
  'billings': ['read', 'write'],
  'brands': ['write'],
  'consumables': ['read', 'write', 'export'],
  'contact_addresses': ['read', 'write', 'export'],
  'ec_accounts': ['read', 'write'],
  'governance': ['read', 'write', 'export'],
  'inbounds': ['read', 'write', 'export'],
  'integrations': ['read', 'write'],
  'inventories': ['read', 'write', 'export', 'approve'],
  'inventory_transformations': ['write'],
  'inventory_type_reclassify_rules': ['write'],
  'logs': ['read'],
  'merchants': ['write'],
  'operators': ['read', 'write'],
  'orders': ['read', 'write', 'export'],
  'organizations': ['read', 'write'],
  'products': ['read', 'write', 'export'],
  'purchase_orders': ['read', 'write', 'export', 'approve'],
  'reports': ['read'],
  'return_orders': ['read', 'write', 'export'],
  'shelves': ['read', 'write', 'export'],
  'shipping_accounts': ['read', 'write'],
  'suppliers': ['read', 'write'],
  'users': ['read', 'write'],
  'warehouses': ['write'],
  'webhooks': ['read', 'write'],
  'work_orders': ['read', 'write'],
} as const;

export const ACTIONS: readonly string[] = [
  'read',
  'write',
  'export',
  'approve',
] as const;

export const RESOURCES_BY_ROLE: Readonly<Record<string, readonly string[]>> = {
  'admin': ['accessible_ip_addresses', 'billings', 'brands', 'consumables', 'contact_addresses', 'ec_accounts', 'governance', 'inbounds', 'integrations', 'inventories', 'inventory_transformations', 'inventory_type_reclassify_rules', 'logs', 'merchants', 'orders', 'products', 'purchase_orders', 'return_orders', 'shelves', 'shipping_accounts', 'suppliers', 'users', 'webhooks'],
  'operator': ['accessible_ip_addresses', 'billings', 'brands', 'consumables', 'contact_addresses', 'ec_accounts', 'governance', 'inbounds', 'inventories', 'logs', 'merchants', 'operators', 'orders', 'organizations', 'products', 'purchase_orders', 'reports', 'return_orders', 'shelves', 'shipping_accounts', 'suppliers', 'users', 'warehouses', 'work_orders'],
} as const;

export const RESOURCE_ACTIONS_BY_ROLE: Readonly<Record<string, Readonly<Record<string, readonly string[]>>>> = {
  'admin': {
    'accessible_ip_addresses': ['read', 'write'],
    'billings': ['read', 'write'],
    'brands': ['write'],
    'consumables': ['read', 'write'],
    'contact_addresses': ['read', 'write', 'export'],
    'ec_accounts': ['read', 'write'],
    'governance': ['read', 'write'],
    'inbounds': ['read', 'write', 'export'],
    'integrations': ['read', 'write'],
    'inventories': ['read', 'write', 'export'],
    'inventory_transformations': ['write'],
    'inventory_type_reclassify_rules': ['write'],
    'logs': ['read'],
    'merchants': ['write'],
    'orders': ['read', 'write', 'export'],
    'products': ['read', 'write', 'export'],
    'purchase_orders': ['read', 'write', 'export', 'approve'],
    'return_orders': ['read', 'write', 'export'],
    'shelves': ['read', 'export'],
    'shipping_accounts': ['read', 'write'],
    'suppliers': ['read', 'write'],
    'users': ['read', 'write'],
    'webhooks': ['read', 'write'],
  },
  'operator': {
    'accessible_ip_addresses': ['read', 'write'],
    'billings': ['read', 'write'],
    'brands': ['write'],
    'consumables': ['read', 'write', 'export'],
    'contact_addresses': ['read', 'write', 'export'],
    'ec_accounts': ['read', 'write'],
    'governance': ['read', 'write', 'export'],
    'inbounds': ['read', 'write', 'export'],
    'inventories': ['read', 'write', 'export', 'approve'],
    'logs': ['read'],
    'merchants': ['write'],
    'operators': ['read', 'write'],
    'orders': ['read', 'write', 'export'],
    'organizations': ['read', 'write'],
    'products': ['read', 'write', 'export'],
    'purchase_orders': ['read', 'write', 'export', 'approve'],
    'reports': ['read'],
    'return_orders': ['read', 'write', 'export'],
    'shelves': ['read', 'write', 'export'],
    'shipping_accounts': ['read', 'write'],
    'suppliers': ['read', 'write'],
    'users': ['read', 'write'],
    'warehouses': ['write'],
    'work_orders': ['read', 'write'],
  },
} as const;
